import React from "react";
import { Link } from "react-router-dom";

export default function NoDataFoundNew(props) {
  const {
    errorCode,
    showImg = true,
    showBtn = true,
    subText = "No data found",
    mainError = "Oops... No Data Found!",
    buttonText = "Back to Home",
    link = "/",
    onBtnClick = () => { }
  } = props;
  return (
    <>
      <div className="row g-5 mt--0">
        <div className="col-lg-12">
          <div className="content text-center">
            <img
              className="error-message"
              src="/images/error-images/404.png"
              alt="No Data Found"
            />
            <h5 className="text-secondary fs-2">{mainError}</h5>
            <div
              className="description fs-3"
              dangerouslySetInnerHTML={{ __html: subText }}
            />
            {showBtn && (
              <div className="backto-home-btn">
                <Link to={link} onClick={onBtnClick} className="edu-btn mt-5">
                  {buttonText}
                  <i className="icon-arrow-right-line-right"></i>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}